import React from "react";

/**
 * @component CheckboxIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <CheckboxIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const CheckboxIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="CheckboxIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <rect stroke="#8E8E8E" x={0.5} y={0.5} width={15} height={15} rx={2} />
        <path
          stroke="#979797"
          strokeWidth={2}
          d="M12.243 5l-5.657 5.657-2.829-2.829"
        />
      </g>
    </svg>
  )
);
CheckboxIcon.displayName = "CheckboxIcon";
export default CheckboxIcon;
